import { render, staticRenderFns } from "./OnlineServiceBooking.vue?vue&type=template&id=25e2f8be"
import script from "./OnlineServiceBooking.vue?vue&type=script&lang=js"
export * from "./OnlineServiceBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports